import { OrderReportColumn } from '../core/enumerations/order-report-column';

export class TableColumns {
  public static OrderReportDialogTableColumnNames = [
    OrderReportColumn[OrderReportColumn.reportName],
    OrderReportColumn[OrderReportColumn.reportType],
    OrderReportColumn[OrderReportColumn.generatedOn],
    OrderReportColumn[OrderReportColumn.share]
  ];
}
